import { saveAs } from "file-saver";
import exceljs from "exceljs";
//--------------------------------------------------------------------------------------------
import { json, jsonArr } from "src/components/common/types";
import { useMyStore } from "src/components/main/mainStore";
import {
    arrayReducer, MyDate, mimeTypeMap, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filterUserList, 
    usersListMap
}:{
    filterUserList:jsonArr, 
    usersListMap:json
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const handlePOExport = (filterUserList: jsonArr, usersListMap: json) => {
        if(!filterUserList.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filterUserList.map(post => [ 
            post.poNumber,
            new Date(post.poDate), 
            usersListMap[JSON.parse(post.approval)[0]?.approverEmail]?.label, 
            JSON.parse(post.approval)[0].approverDecision, 
            JSON.parse(post.approval)[0].reviewTime?
            new Date(JSON.parse(post.approval)[0]?.reviewTime?.replace(/-/g, "/")):"", 
            usersListMap[JSON.parse(post.approval)[1]?.approverEmail]?.label,
            JSON.parse(post.approval)[1]?.approverDecision, 
            JSON.parse(post.approval)[1]?.reviewTime?
            new Date(JSON.parse(post.approval)[1]?.reviewTime?.replace(/-/g, "/")):"", 
            post.notes, 
            new Date(post.submitTime?.replace(/-/g, "/")), 
            post.submitter, 
            post.updater, 
            post.dateUpdated?new Date(post.dateUpdated?.replace(/-/g, "/")):"", 
            post.projectName, 
            post.btlNumber, 
            post.category, 
            post.requestor, 
            post.paymentMethod, 
            post.last4, 
            post.billable,
            post.includedInProposal,
            post.truckNumber?JSON.parse(post.truckNumber).map((truck: json) => truck.truckNumber).join(", "):"",
            window.Number.parseFloat(post.total),
            window.Number.parseFloat(post.discount), 
            window.Number.parseFloat(post.tax),
            window.Number.parseFloat(post.subtotal),
            post.quoteLink,
            post.receiptLink,
            post.poType,
            post.department,
            post.paid,
            post.billed,
            post.permit,
            post.void,
            post.voidReason,
            post.notify ?? "",
            post.decision,
            ...JSON.parse(post.data).map((line: json) => [line.vendorName, line.description, line.unitPrice, line.quantity, line.lineTotal]).reduce(arrayReducer, []),
        ])
        const maxLength = Math.max(...(filterUserList.map(f => JSON.parse(f.data).length)));
        const dataCode = ["Vender Name", "Description", "Unit Price", "Quantity", "Line Total"];
        const dataHeader = Array.from({length: maxLength * 5}, (v, i) => ({
            name: `${dataCode[i % 5]} ${Math.floor(i/5 + 1)}`, filterButton: true
        }));
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "PO Number", filterButton: true},
                { name: "PO Date", filterButton: true},
                { name: "Approver 1 Name", filterButton: true},
                { name: "Approver 1 Decision", filterButton: true},
                { name: "Approver 1 Review Time", filterButton: true},
                { name: "Approver 2 Name", filterButton: true},
                { name: "Approver 2 Decision", filterButton: true},
                { name: "Approver 2 Review Time", filterButton: true},
                { name: "Notes", filterButton: true},
                { name: "Submit Time", filterButton: true},
                { name: "Submitter", filterButton: true},
                { name: "Updater", filterButton: true},
                { name: "Date Updated", filterButton: true},
                { name: "Project Name", filterButton: true},
                { name: "BTL Number", filterButton: true},
                { name: "Category", filterButton: true},
                { name: "Requestor", filterButton: true},
                { name: "Payment Method", filterButton: true},
                { name: "Last 4 Digit", filterButton: true},
                { name: "Billable", filterButton: true},
                { name: "Included In Proposal", filterButton: true},
                { name: "Truck Number", filterButton: true},
                { name: "Total", filterButton: true, totalsRowFunction: "sum"},
                { name: "Discount", filterButton: true, totalsRowFunction: "sum"},
                { name: "Tax", filterButton: true, totalsRowFunction: "sum"},
                { name: "Subtotal", filterButton: true, totalsRowFunction: "sum"},
                { name: "Quote Link", filterButton: true},
                { name: "Receipt Link", filterButton: true},
                { name: "PO Type", filterButton: true},
                { name: "Department", filterButton: true},
                { name: "Paid", filterButton: true},
                { name: "Billed", filterButton: true},
                { name: "Permit", filterButton: true},
                { name: "Void", filterButton: true},
                { name: "Void Reason", filterButton: true},
                { name: "Notify", filterButton: true},
                { name: "Status", filterButton: true},
                ...dataHeader
            ],
            rows: rows,
        });
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `PO export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
return <span className = "pointer" onClick = {() => handlePOExport(
    filterUserList, 
    usersListMap
)}>Export</span>
}